import { get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';
import {
	isSensorPriorityDevForceForFamily,
	type SensorPriorityDevForce,
	type SensorPriorityFamily,
} from 'src/helpers/sensor_priority_layout';
import { claimPriorityLayoutDevHud } from 'src/stores/features/dev/priority-layout-dev-hud-state';

const STORAGE_KEY = 'shelly_dev_sensor_priority_force';

const readInitialValue = (): SensorPriorityDevForce => {
	if (!isNonProductionAppBuild()) return 'auto';
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) return stored as SensorPriorityDevForce;
	} catch {
		// localStorage may be unavailable
	}
	return 'auto';
};

/**
 * Dev-only H&T / Door-Window / Motion Main-tab layout force.
 * Production builds stay on auto. Preference is local-only.
 */
export const sensorPriorityDevForce = writable<SensorPriorityDevForce>(readInitialValue());

export const sensorPriorityDevHudFamily = writable<SensorPriorityFamily>('ht');
export const sensorPriorityDevHudIsBle = writable(true);

sensorPriorityDevForce.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

export const setSensorPriorityDevHudContext = (family: SensorPriorityFamily, isBle: boolean) => {
	if (!isNonProductionAppBuild()) {
		sensorPriorityDevHudFamily.set('ht');
		sensorPriorityDevHudIsBle.set(true);
		return;
	}
	sensorPriorityDevHudFamily.set(family);
	sensorPriorityDevHudIsBle.set(isBle);
	const force = get(sensorPriorityDevForce);
	if (!isSensorPriorityDevForceForFamily(family, force, isBle)) {
		sensorPriorityDevForce.set('auto');
	}
};

export const claimSensorPriorityDevHud = (
	family: SensorPriorityFamily,
	isBle: boolean,
): (() => void) => {
	setSensorPriorityDevHudContext(family, isBle);
	return claimPriorityLayoutDevHud('sensor');
};

export const getSensorPriorityDevForce = (): SensorPriorityDevForce =>
	isNonProductionAppBuild() ? get(sensorPriorityDevForce) : 'auto';

export const setSensorPriorityDevForce = (force: SensorPriorityDevForce) => {
	sensorPriorityDevForce.set(isNonProductionAppBuild() ? force : 'auto');
};
